import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["copyHint"];

  static values = {
    url: String,
    shareTitle: String,
  };

  connect() {
    this.copyHintTimeout = null;
  }

  disconnect() {
    if (this.copyHintTimeout) {
      window.clearTimeout(this.copyHintTimeout);
      this.copyHintTimeout = null;
    }
  }

  async copy(event) {
    event?.preventDefault();
    await this.copyUrlToClipboard();
    this.showCopyHint();
  }

  async shareMore(event) {
    event.preventDefault();

    const shareUrl = this.currentUrl();
    const shareData = {
      title: this.shareTitleValue || "",
      url: shareUrl,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return;
      } catch (error) {
        if (error?.name === "AbortError") {
          return;
        }
      }
    }

    await this.copyUrlToClipboard();
    this.showCopyHint();
  }

  currentUrl() {
    if (this.urlValue) {
      return this.urlValue;
    }

    return window.location.href;
  }

  async copyUrlToClipboard() {
    const url = this.currentUrl();
    if (!url) {
      return;
    }

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(url);
        return;
      } catch (_error) {
      }
    }

    this.copyUsingLegacyApi(url);
  }

  copyUsingLegacyApi(url) {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    textArea.remove();
  }

  showCopyHint() {
    if (!this.hasCopyHintTarget) {
      return;
    }

    this.copyHintTarget.hidden = false;

    if (this.copyHintTimeout) {
      window.clearTimeout(this.copyHintTimeout);
    }

    this.copyHintTimeout = window.setTimeout(() => {
      if (this.hasCopyHintTarget) {
        this.copyHintTarget.hidden = true;
      }
    }, 1200);
  }
}
